import { createFileRoute } from "@tanstack/react-router";
import SelfButtonsWork from "@/features/assessments/pages/self-buttons-work/SelfButtonsWork";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-buttons-work")({
	component: SelfButtonsWork,
});
